<template>
    <div class="dialog-overlay" v-if="show">
        <div class="dialog">
            <p class="dialog__title" v-if="title">{{ getTranslatedText(title) }}</p>
            <p v-if="content" class="dialog__content">
                {{ isTranslatedContent ? getTranslatedText(content) : content }}
            </p>
            <slot name="dialogContent"></slot>
            <div v-if="isShowTable" class="dialog__table">
                <div
                    class="dialog__table--item"
                    v-for="item in dataTable"
                    :key="item"
                >
                    <p>{{ getTranslatedText(item.title) }}</p>
                    <p>{{ item.value }}</p>
                </div>
            </div>
            <div class="dialog__action" v-if="isShowButton">
                <button class="close-button" @click="closeDialog">
                    {{ getTranslatedText(buttonLeftName) }}
                </button>
                <button class="accept-button" @click="accept">
                    {{ getTranslatedText(buttonRightName) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";
export default {
    mixins: [languageMixins],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        buttonLeftName: {
            type: String,
            default: "",
        },
        buttonRightName: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        content: {
            type: [String, Object, Array],
            default: "",
        },
        isShowTable: {
            type: Boolean,
            default: false,
        },
        dataTable: {
            type: Array,
        },
        isTranslatedContent: {
            type: Boolean,
            default: true,
        },
        isShowButton: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        closeDialog() {
            this.$emit("close");
        },

        accept() {
            this.$emit("accept");
        },
    },
};
</script>

<style lang="scss">
@import "@/public/scss/common/dialog.scss";
</style>
